import React from 'react';
import '../styles/components/AppIntroduction.css';

function AppIntroduction() {
  return (
    <div className="app-introduction">
      <header>
        <h1>「EmotionLog（エモーションログ）」アプリ紹介ページ</h1>
      </header>

      <section>
        <h2>アプリ概要</h2>
        <p>「EmotionLog」は、日々の感情を1タップで手軽に記録し、カレンダーやグラフで振り返れるアプリです。うれしい・かなしい・怒り・不安などの感情を選び、任意のメモも残せます。過去の変化を可視化し、自己理解を深めるサポートをします。</p>
      </section>

      <section>
        <h2>主な機能</h2>
        <div className="features">
          <div className="feature">
            <div className="feature-text">
              <h3>記録と履歴</h3>
              <ul>
                <li>1タップで感情を選択（うれしい／かなしい／怒り／不安 など）</li>
                <li>任意メモの追加（最大500文字）</li>
                <li>感情は後で設定も可能</li>
                <li>カレンダー表示と日別の履歴一覧で振り返り</li>
                <li>詳細画面で当日の感情・メモを確認／編集</li>
              </ul>
            </div>
            <img src="/app_introduction/images/app_screenshot.png" alt="EmotionLog スクリーンショット" />
          </div>
          <div className="feature">
            <div className="feature-text">
              <h3>分析と設定</h3>
              <ul>
                <li>週・月ごとの傾向をグラフで可視化</li>
                <li>最も多かった感情の割合を集計</li>
                <li>リマインダー通知</li>
              </ul>
            </div>
            <img src="/app_introduction/images/app_settings.png" alt="EmotionLog 設定画面" />
          </div>
        </div>
      </section>

      <section className="contact">
        <p>お問い合わせ：<a href="mailto:developer.poteto.contact@gmail.com">こちら</a></p>
      </section>
    </div>
  );
}

export default AppIntroduction; 